import type { IllustrationName } from "../../../types/IllustrationType";

export enum AnalysisSectionIndex {
  EnvironmentAndNeighborhood = 1,
  ExteriorAndOutdoorSpaces = 2,
  EntranceAndLayout = 3,
  TechnologyAndEnergy = 4,
  SafetyAndMaterials = 5,
  GeneralAndLegal = 6,
  //
  ALookInside = 7,
  InTheNeighborhood = 8,
  PropertyHazardProfile = 9,
  SunPosition = 10,
  PropertyValueDevelopment = 11,
  MaintenanceAndRenovation = 12,
  FinancingTheProperty = 13,
}

export const analysisSectionIndexLabels: Record<AnalysisSectionIndex, string> =
  {
    [AnalysisSectionIndex.EnvironmentAndNeighborhood]: "Omgeving & buurt",
    [AnalysisSectionIndex.ExteriorAndOutdoorSpaces]:
      "Exterieur & buitenruimtes",
    [AnalysisSectionIndex.EntranceAndLayout]: "Entree & indeling",
    [AnalysisSectionIndex.TechnologyAndEnergy]: "Techniek & energie",
    [AnalysisSectionIndex.SafetyAndMaterials]: "Veiligheid & materialen",
    [AnalysisSectionIndex.GeneralAndLegal]: "Algemeen & juridisch",
    [AnalysisSectionIndex.ALookInside]: "Een kijkje binnen",
    [AnalysisSectionIndex.InTheNeighborhood]: "In de buurt",
    [AnalysisSectionIndex.SunPosition]: "Zonnestand",
    [AnalysisSectionIndex.PropertyValueDevelopment]:
      "Ontwikkeling woningwaarde",
    [AnalysisSectionIndex.MaintenanceAndRenovation]: "Onderhoud & renovatie",
    [AnalysisSectionIndex.PropertyHazardProfile]: "Funderingsrisico's",
    [AnalysisSectionIndex.FinancingTheProperty]: "Woning financieren",
  };

export const analysisSectionIllustrations: Record<
  AnalysisSectionIndex,
  IllustrationName
> = {
  [AnalysisSectionIndex.EnvironmentAndNeighborhood]: "neighbourhood",
  [AnalysisSectionIndex.ExteriorAndOutdoorSpaces]: "outside",
  [AnalysisSectionIndex.EntranceAndLayout]: "living",
  [AnalysisSectionIndex.TechnologyAndEnergy]: "technology",
  [AnalysisSectionIndex.SafetyAndMaterials]: "materials",
  [AnalysisSectionIndex.GeneralAndLegal]: "clipboard",
  [AnalysisSectionIndex.ALookInside]: "kitchen",
  [AnalysisSectionIndex.InTheNeighborhood]: "neighbourhood",
  [AnalysisSectionIndex.SunPosition]: "sun",
  [AnalysisSectionIndex.PropertyValueDevelopment]: "price",
  [AnalysisSectionIndex.MaintenanceAndRenovation]: "maintenance",
  [AnalysisSectionIndex.PropertyHazardProfile]: "foundation",
  [AnalysisSectionIndex.FinancingTheProperty]: "refinance",
};
